export const URL_API = 'https://api.pradini.id/'
export const ONE_SIGNAL_ID = '379f3135-bba0-49e9-9cbe-394a70c5b38c';
export const ONE_SIGNAL_KEY = 'Mjg1OWJlMGItNTk3Zi00YTA0LThhZTYtNzlkMzQ5NjRjMTlj';